/**
 * resource component to manage how programs should be displayed
 * by the sponsor. 
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import ProgramAgendaItemsManager from './ProgramAgendaItemsManager.js.jsx';
import GroupWithSponsorAgendaItems from './GroupWithSponsorAgendaItems.js.jsx';

// import actions
import * as studyActions from '../../study/studyActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// not updating links here because this should no longer be used with london handling agenda

class SponsorAgendaManager extends Base {
  constructor(props) {
    super(props);
    this.state = {
      numShowingPrograms: 10
    }
  }

  componentDidMount() {
    const { dispatch, loggedInUser, sponsor } = this.props;
    dispatch(contentModuleActions.fetchListIfNeeded('sponsor-agenda', sponsor._id, 'group-with', false));
    dispatch(contentModuleActions.fetchListIfNeeded('sponsor-agenda', sponsor._id, 'group-with', true));
    dispatch(studyActions.fetchListIfNeeded('user', loggedInUser._id, `?memberContent.groupWithSponsor=false&_organization=${sponsor._id}`))
    /**
     * NOTE TO SELF 
     * 
     * ^ this needs to account for the specific sponsor, otherwise we end up cross 
     * polinating studies/sponsors --- i.e. an Avenir study showing up in under Otsuka 
     */
  
  }

  render() {
    const { 
      loggedInUser
      , showAllGrouped
      , sponsor 
      , studyStore 
      , contentModuleStore
    } = this.props;
    const { numShowingPrograms } = this.state;

    const groupedTmList = 
      sponsor 
      && contentModuleStore.lists['sponsor-agenda'] 
      && contentModuleStore.lists['sponsor-agenda'][sponsor._id]
      && contentModuleStore.lists['sponsor-agenda'][sponsor._id]['group-with'] 
      && contentModuleStore.lists['sponsor-agenda'][sponsor._id]['group-with'].true 
    ? 
      contentModuleStore.lists['sponsor-agenda'][sponsor._id]['group-with'].true 
    : 
      {};
    const itemsGroupedWithSponsor = groupedTmList ? groupedTmList.agendaItems : [];

    const tmList = 
      sponsor 
      && contentModuleStore.lists['sponsor-agenda'] 
      && contentModuleStore.lists['sponsor-agenda'][sponsor._id]
      && contentModuleStore.lists['sponsor-agenda'][sponsor._id]['group-with'] 
      && contentModuleStore.lists['sponsor-agenda'][sponsor._id]['group-with'].false 
    ? 
      contentModuleStore.lists['sponsor-agenda'][sponsor._id]['group-with'].false 
    : 
      {};
    const agendaItems = tmList ? tmList.agendaItems : [];
    const itemsGroupedByStudy = _.groupBy(agendaItems, '_group');
    // console.log(itemsGroupedByStudy);

    const ungroupedStudiesList = 
      studyStore.lists.user 
      && studyStore.lists.user[loggedInUser._id]
      && studyStore.lists.user[loggedInUser._id][`?memberContent.groupWithSponsor=false&_organization=${sponsor._id}`] 
    ? 
      studyStore.lists.user[loggedInUser._id][`?memberContent.groupWithSponsor=false&_organization=${sponsor._id}`] 
    : 
      {};
    
    const ungroupedStudies = studyStore.util.getList('user', loggedInUser._id, `?memberContent.groupWithSponsor=false&_organization=${sponsor._id}`);
    
    const isEmpty = (
      !groupedTmList
      || !ungroupedStudiesList 
    )

    const isFetching = (
      !groupedTmList
      || groupedTmList.isFetching
      || !ungroupedStudiesList 
      || ungroupedStudiesList.isFetching
    )
    
    return (
      <div>
        { isEmpty ?
          (isFetching ?
            <div className="u-centerText">
              <div className="loading"></div>
            </div>
          :
            <div className="u-centerText">
              <h2>No simulations were found!</h2>
              <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
              <p>Or navigate to your <Link to="/my-agenda">Programs</Link> to select a specific program!</p>
            </div>
          )
          :
          <div  className="-study-wrapper"> 
            <div className="yt-row">
              <h2 className="sponsor-title">{sponsor.name}</h2>
              { sponsor.logo ? 
                <img className="-agenda-logo" src={sponsor.logo}/>
              : null
              }
            </div>
            { itemsGroupedWithSponsor && itemsGroupedWithSponsor.length > 0 ?
              <GroupWithSponsorAgendaItems
                agendaItems={itemsGroupedWithSponsor}
                sponsor={sponsor}
                showAll={showAllGrouped}
              />
              :
              null 
            }
            { showAllGrouped && ungroupedStudies && ungroupedStudies.length > 0 ?
              <div style={{marginTop: '40px', marginBottom: '40px'}}>
                <hr/>
                <h2>Additional program specific training</h2>
              </div>
              : null
            }
            {ungroupedStudies && ungroupedStudies.sort((a,b) => a.orderWeight - b.orderWeight).slice(0, numShowingPrograms).map((study, i) =>
              <div>
                {study && study.memberContent && study.memberContent.hasAccess ?
                  <ProgramAgendaItemsManager
                    agendaItems={itemsGroupedByStudy[study._id]}
                    key={'ungrouped_' + study._id + '_' + i}
                    sponsor={sponsor}
                    study={study}
                    // showOptional={true}
                  />
                : null
                }
              </div>
            )}
            {ungroupedStudies && ungroupedStudies.length > numShowingPrograms ? 
              <div style={{marginBottom: 20}}>
                <button className="yt-btn small secondary" onClick={() => this.setState({numShowingPrograms: numShowingPrograms + 10})}>Show more programs sponsored by {sponsor.name}</button>
              </div>
              :
              null 
            }
            <hr/>
          </div>
        }
      </div>
    )
  }
}

SponsorAgendaManager.propTypes = {
  dispatch: PropTypes.func.isRequired
  , groupedStudies: PropTypes.array 
  , showAllGrouped: PropTypes.bool 
  , sponsor: PropTypes.object.isRequired
  , ungroupedStudies: PropTypes.array 
}

SponsorAgendaManager.defaultProps = {
  groupedStudies: []
  , showAllGrouped: false 
  , ungroupedStudies: []
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , studyStore: store.study 
    , contentModuleStore: store.contentModule 
  }
}

export default connect(mapStoreToProps)(SponsorAgendaManager);



// WEBPACK FOOTER //
// modules/agenda/components/SponsorAgendaManager.js.jsx